export default [
  {
    title: 'Orders',
    icon: 'mdi-basket-outline',
    route: 'orders',
    children: [
      { title: 'Current', icon: 'mdi-account-box', to: '/orders/list/current' },
      { title: 'Cancelled', icon: 'mdi-account-box', to: '/orders/list/cancelled' },
      { title: 'Completed', icon: 'mdi-account-box', to: '/orders/list/completed' },
    ],
  },
  {
    title: 'Pre-made lobbies',
    icon: 'mdi-sofa-outline',
    route: 'lobbies',
    children: [
      { title: 'Current', icon: 'mdi-account-box', to: '/lobbies/current' },
      { title: 'Completed', icon: 'mdi-account-box', to: '/lobbies/completed' },
    ],
  },
  {
    title: 'Your clients',
    icon: 'mdi-account-multiple',
    route: 'clients',
    to: '/clients/list',
    children: [],
  },
  {
    title: 'Payouts',
    icon: 'mdi-credit-card-outline',
    to: '/payouts',
    children: [],
  },

];
